export const LABEL_MARQUE_NON_REFERENCEE = 'Non référencée';
export const LABEL_MODELE_NON_REFERENCE = 'Non référencé';
export const LABEL_SANS_PLAQUE = 'Sans plaque';
export const LABEL_IMMAT_MANQUANTE = 'Immatriculation manquante';
export const LABEL_DONNEE_EXPIREE = 'Donnée expirée';
export const VALUE_NON_REFERENCE = 'unknown';
export const LABEL_NON_RENSEIGNE = 'Non renseigné';
export const LABEL_ID_CORRELATION = 'Id de corrélation';
export const DEBOUNCE_DELAY_DEFAULT = 500;

export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50];
